import { Component, EventEmitter, Input, Output, input } from '@angular/core';
import { Location, NgClass } from '@angular/common';
import { fadeInOut, fadeInOutHidden } from 'src/app/constants/animations';
import { HouseholdQuoteStateService } from 'src/app/services/household-quote-state-service/household-quote-state.service';
import { GoogleTagManagerService } from 'src/app/services/google-analytics/google-tag-manager.service';
@Component({
    selector: 'app-calc-nav-buttons',
    templateUrl: './calc-nav-buttons.component.html',
    styleUrls: ['./calc-nav-buttons.component.scss'],
    animations: [
        fadeInOut,
        fadeInOutHidden
    ],
    imports: [NgClass]
})
export class CalcNavButtonsComponent {
    readonly showNextBtn = input<boolean>(true);
    readonly showBackBtn = input<boolean>(true);
    readonly showExitBtnDesktop = input<boolean>(true);
    readonly nextBtnText = input<string>('Next');
    readonly backBtnText = input<string>('Back');
    @Input() idText: string | undefined;
    readonly disableNextBtn = input<boolean>(false);
    readonly showNextBtnDisabled = input<boolean>(false);
    readonly disableBackBtn = input<boolean>(false);
    @Input() loading: boolean = false;
    readonly showNextBtnIcon = input<boolean>(false);
    readonly showBackBtnIcon = input<boolean>(true);


    @Output() nextBtnClick = new EventEmitter<any>();
    @Output() backBtnClick = new EventEmitter<any>();

    constructor(
        public householdQuoteStateService: HouseholdQuoteStateService,
        private location: Location,
        private googleTagManagerService: GoogleTagManagerService) { }

    public onNextBtnClick(): void {
        this.googleTagManagerService.trackAction('button_click', 'click', `continue_btn`, `continue_btn`);
        this.nextBtnClick.emit();
    }

    public onBackBtnClick(): void {
        this.googleTagManagerService.trackAction('button_click', 'click', `back_btn`, `back_btn`);
        this.location.back();
        this.backBtnClick.emit();
    }
}
